import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
import {TITLE_DESCRIPTION} from 'src/interfaces/Template.interface'


interface paramQuery {
  platform_Id?: any
  page?: number
  limit?: number
  search_string?: string
  use_pagination?: boolean
  platform_field_id?: any
  selected_value?: any
}


const sanitizeQueryParam = (value: any) => {
      if (value === undefined || value === null) {
        return ''
      }
      return String(value)
    }


export const savePlatformTitleDescriptionTemplateAsync = createAsyncThunk(
  'platform/savePlatformTitleDescriptionTemplateAsync',
  async function (payload: TITLE_DESCRIPTION, toolkit) {
    const url = `/platform-title-description-template`


    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)
export const getPlatformTitleDescriptionTemplateAsync = createAsyncThunk(
  'platform/getPlatformTitleDescriptionTemplateAsync',
  async function (
    params: {platform_id?: string; paginationdata: {page: number; limit: number; search: string}},
    toolkit
  ) {
    const url = `/platform-title-description-template?platform_id=${params.platform_id}`


    return await AxiosClient('GET', url, [], toolkit, params.paginationdata)
  }
)


export const updateTitleDescriptionTemplateAsync = createAsyncThunk(
  'platform/updateTitleDescriptionTemplateAsync',
  async function (params: {platform_id?: string; payload: any}, toolkit) {
    const url = `/platform-title-description-template/${params.platform_id}`


    return await AxiosClient('PUT', url, params.payload, toolkit, [])
  }
)


export const getTitleDescriptionTemplateByIdAsync = createAsyncThunk(
  'platform/getTitleDescriptionTemplateByIdAsync',
  async function (params: { templateId: number | string }, toolkit) {
    return await AxiosClient(
      'GET',
      `/platform-title-description-template/${params.templateId}`,
      [],
      toolkit,
      []
    )
  }
)

export const deleteTitleDescriptionTemplateAsync = createAsyncThunk(
  'platform/deleteTitleDescriptionTemplateAsync',
  async function (params: {platform_id?: string}, toolkit) {
    const url = `/platform-title-description-template/${params.platform_id}`


    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

export const getImageTemplateMappingForPlatformAsync = createAsyncThunk(
  'platform/getImageTemplateMappingForPlatformAsync',
  async function (
    params: { platformId: number; templateMappingId?: number | null },
    toolkit
  ) {
    const queryParams: Record<string, string> = {
      platform_id: String(params.platformId),
    }
    if (params.templateMappingId != null && params.templateMappingId > 0) {
      queryParams.template_mapping_id = String(params.templateMappingId)
    }
    return await AxiosClient(
      'GET',
      `/api/image-template-mapping-for-platform`,
      [],
      toolkit,
      queryParams
    )
  }
)

export const saveImageTemplateMappingForPlatformAsync = createAsyncThunk(
  'platform/saveImageTemplateMappingForPlatformAsync',
  async function (payload: any, toolkit) {
    return await AxiosClient(
      'POST',
      `/api/image-template-mapping-for-platform`,
      payload,
      toolkit,
      []
    )
  }
)

export const deleteImageTemplateMappingDataAsync = createAsyncThunk(
  'platform/deleteImageTemplateMappingDataAsync',
  async function (
    params: {
      platformId: number
      imageTemplateMappingId: number
      imageTemplateMappingDataId: number
    },
    toolkit
  ) {
    return await AxiosClient(
      'DELETE',
      `/api/image-template-mapping-for-platform`,
      [],
      toolkit,
      {
        platform_id: String(params.platformId),
        image_template_mapping_id: String(params.imageTemplateMappingId),
        image_template_mapping_data_id: String(params.imageTemplateMappingDataId),
      }
    )
  }
)
export const getShortCodeAsync = createAsyncThunk(
  'platform/getShortCodeAsync',
  async function (params: {shortcode_type?: string; search_string: string}, toolkit) {
    const url = `/shortcode?shortcode_type=${params.shortcode_type}&search_string=`


    return await AxiosClient('GET', url, [], toolkit, [])
  }
)


//get parent categories
export const getPlatformParentFieldDataCategoriesAsync = createAsyncThunk(
  'template&pricing/getPlatformParentFieldDataCategoriesAsync',
  async function (
    params: paramQuery,
    toolkit
  ) {
    const queryParams = {
      page: sanitizeQueryParam(params.page),
      limit: sanitizeQueryParam(params.limit),
      search_string: sanitizeQueryParam(params.search_string),
      use_pagination: sanitizeQueryParam(params.use_pagination),
      platform_field_id: sanitizeQueryParam(params.platform_field_id),
      selected_value: sanitizeQueryParam(params.selected_value),
    }


    const queryString = Object.entries(queryParams)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')


    const url = `/api/platform-parent-field-data/${params.platform_Id ?? ''}?${queryString}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)


export const getPlatformFieldDataCategoriesAsync = createAsyncThunk(
  'template&pricing/getPlatformFieldDataCategoriesAsync',
  async function (params: {platform_field_ids: []}, toolkit) {
    const url = `/api/platform-parent-field-data?platform_field_id_list=${params.platform_field_ids}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)


//get child categories
export const getPlatformChildFieldDataCategoriesAsync = createAsyncThunk(
  'template&pricing/getChildCategoriesAsync',
  async function (params: paramQuery, toolkit) {
     const queryParams = {
      page: sanitizeQueryParam(params.page),
      limit: sanitizeQueryParam(params.limit),
      search_string: sanitizeQueryParam(params.search_string),
      use_pagination: sanitizeQueryParam(params.use_pagination),
      platform_field_id: sanitizeQueryParam(params.platform_field_id),
      selected_value: sanitizeQueryParam(params.selected_value),
    }


    const queryString = Object.entries(queryParams)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')
    const url = `/api/get-child-field-data/${params.platform_Id ?? ''}?${queryString}`


    return await AxiosClient('GET', url, [], toolkit, [])
  }
)


//in recipe side when user add rule for category then we need to get parent first after that we get the sub categories from that parent
export const getPlatformParentFieldDataWhenPlatformIsCategorySelectedAsync = createAsyncThunk(
  'template&pricing/getPlatformParentFieldDataWhenPlatformIsCategorySelectedAsync',
  async function (params: {subCategory_id: any}, toolkit) {
    const url = `/api/get-field-data-tree/${params.subCategory_id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)


//get  getPlatformFieldDataAttributesAsync   when filedset=""


export const getPlatformFieldDataAttributesAsync = createAsyncThunk(
  'template&pricing/getPlatformFieldDataAttributesAsync',
  async function (params: {category_id: number; platform_id?: number | string}, toolkit) {
    const query = params.platform_id ? `?platform_id=${params.platform_id}` : ''
    const url = `/api/platform-field-data-attributes/${params.category_id}${query}`


    return await AxiosClient('GET', url, [], toolkit, [])
  }
)

export const refreshPlatformFieldDataAttributesAsync = createAsyncThunk(
  'template&pricing/refreshPlatformFieldDataAttributesAsync',
  async function (params: {platform_field_data_id: number; platform_id?: number | string}, toolkit) {
    const query = params.platform_id ? `?platform_id=${params.platform_id}` : ''
    const url = `/api/platform-field-data-attributes-re-import/${params.platform_field_data_id}${query}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)


//post attributes


export const postFieldDataAttributesAsync = createAsyncThunk(
  'template&pricing/postFieldDataAttributesAsync',
  async function (payload: any, toolkit) {
    const url = `/platform-category-template`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)


//get  platform-category-template
export const getFieldDataAttributesAsync = createAsyncThunk(
  'template&pricing/getFieldDataAttributesAsync',
  async function (payload: {category_template: number}, toolkit) {
    const url = `/platform-category-template/${payload.category_template}`
    return await AxiosClient('GET', url, payload, toolkit, [])
  }
)


//get platform  platform-category-template data
export const getPlatformCategoryTemplateDataAsync = createAsyncThunk(
  'template&pricing/getPlatformCategoryTemplateDataAsync',
  async function (
    payload: {platform_id: number; paginationdata: {page: number; limit: number; search: string}},
    toolkit
  ) {
    const url = `/platform-category-template?platform_id=${payload.platform_id}`
    return await AxiosClient('GET', url, payload, toolkit, payload.paginationdata)
  }
)


//delete platform-category-template data
export const deleteCategoryTemplateDataAsync = createAsyncThunk(
  'template&pricing/deleteCategoryTemplateDataAsync',
  async function (payload: {category_template: number}, toolkit) {
    const url = `/platform-category-template/${payload.category_template}`
    return await AxiosClient('DELETE', url, payload, toolkit, [])
  }
)


//update   platform-category-template data
export const updateCategoryTemplateDataAsync = createAsyncThunk(
  'template&pricing/updateCategoryTemplateDataAsync',
  async function (payload: {category_template: number; payloadupdate: any}, toolkit) {
    const url = `/platform-category-template/${payload.category_template}`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)


export const getSelectedCategoryTreeAsync = createAsyncThunk(
  'template&pricing/getSelectedCategoryTreeAsync',
  async function (params: {category_data_id: number}, toolkit) {
    return await AxiosClient(
      'GET',
      `/api/get-field-data-tree/${params.category_data_id}`,
      [],
      toolkit,
      []
    )
  }
)

// flattened tree search for categories (returns breadcrumbed api_name)
export const getFieldTreeSearchAsync = createAsyncThunk(
  'template&pricing/getFieldTreeSearchAsync',
  async function (
    params: {
      categoryId: number
      platform_field_id: number
      search_string: string
      page?: number
      limit?: number
      use_pagination?: boolean
      selected_child_id?: number
    },
    toolkit
  ) {
    const queryParams = {
      page: sanitizeQueryParam(params.page ?? 1),
      limit: sanitizeQueryParam(params.limit ?? 200),
      search_string: sanitizeQueryParam(params.search_string),
      use_pagination: sanitizeQueryParam(params.use_pagination ?? true),
      platform_field_id: sanitizeQueryParam(params.platform_field_id),
      selected_child_id: sanitizeQueryParam(params.selected_child_id),
    }

    const queryString = Object.entries(queryParams)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')

    return await AxiosClient(
      'GET',
      `/api/get-field-tree/${params.categoryId}?${queryString}`,
      [],
      toolkit,
      []
    )
  }
)


//get platform  platform-category-template data
export const getCategoryTemplateUsingTemplateIdAsync = createAsyncThunk(
  'template&pricing/getCategoryTemplateUsingTemplateIdAsync',
  async function (payload: {category_temp_id: number}, toolkit) {
    return await AxiosClient(
      'GET',
      `/platform-category-template/${payload.category_temp_id}`,
      payload,
      toolkit,
      []
    )
  }
)


export const createRecipeAsync = createAsyncThunk(
  'templateMapping/createRecipeAsync',
  async function (payload: any, toolkit) {
    return await AxiosClient('POST', `/api/template-mapping`, payload, toolkit, [])
  }
)


export const updateRecipeAsync = createAsyncThunk(
  'templateMapping/updateRecipeAsync',
  async function (params: {recipeId: string; payload: any}, toolkit) {
    return await AxiosClient(
      'PUT',
      `/api/template-mapping/${params.recipeId}`,
      params.payload,
      toolkit,
      []
    )
  }
)


export const deleteRecipeAsync = createAsyncThunk(
  'templateMapping/deleteRecipeAsync',
  async function (params: {templateMappingId: string; type?: string}, toolkit) {
    return await AxiosClient(
      'DELETE',
      `/api/template-mapping/${params.templateMappingId}`,
      [],
      toolkit,
      params.type ? {type: params.type} : []
    )
  }
)


export const duplicateRecipeAsync = createAsyncThunk(
  'templateMapping/duplicateRecipeAsync',
  async function (params: {recipeId: string | number}, toolkit) {
    return await AxiosClient(
      'POST',
      `/api/template-mapping-duplicate/${params.recipeId}`,
      {},
      toolkit,
      []
    )
  }
)



export const deleteRecipeMappingItemAsync = createAsyncThunk(
  'templateMapping/deleteRecipeMappingItemAsync',
  async function (params: {templateMappingItemId: string}, toolkit) {
    return await AxiosClient(
      'DELETE',
      `/api/template-mapping-data/${params.templateMappingItemId}`,
      [],
      toolkit,
      []
    )
  }
)


export type GetRecipesAsyncParams = {
  /** Legacy: platform id in URL path. Unified list: omit or use query filter only. */
  platformId?: string
  /** When true (default), GET `/api/template-mapping-for-platform/{platformId}`. */
  usePlatformPath?: boolean
  otherParams: {
    page: number
    limit: number
    search: string
    type?: string
    sort_by?: string
    sort_order?: string
  }
}

export const getRecipesAsyncUsingPlatformId = createAsyncThunk(
  'templateMapping/getRecipesAsyncUsingPlatformId',
  async function (params: GetRecipesAsyncParams, toolkit) {
    const usePath = params.usePlatformPath !== false && Boolean(params.platformId)
    const path = usePath
      ? `/api/template-mapping-for-platform/${params.platformId}`
      : `/api/template-mapping-for-platform`
    return await AxiosClient('GET', path, [], toolkit, params.otherParams)
  }
)


export const getRecipesAsyncUsingRecipeId = createAsyncThunk(
  'templateMapping/getRecipesAsyncUsingRecipeId',
  async function (params: {recipeId: string; otherParams: any}, toolkit) {
    return await AxiosClient(
      'GET',
      `/api/template-mapping/${params.recipeId}`,
      [],
      toolkit,
      params.otherParams
    )
  }
)


export const getCategoriesByPlatformIdAsync = createAsyncThunk(
  'templateMapping/getCategoriesByPlatformIdAsync',
  async function (
    params: {platformId: string; paginationdata: {page: number; limit: number; search: string}},
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `/platform-category-template?platform_id=${params.platformId}`,
      [],
      toolkit,
      params.paginationdata
    )
  }
)


//more mapping rules


export const createMoreMappingAsync = createAsyncThunk(
  'templateMapping/createMoreMappingAsync',
  async function (payload: any, toolkit) {
    return await AxiosClient('POST', `/platform-field-template`, payload, toolkit, [])
  }
)


// export const getMoreMappingAsync = createAsyncThunk(
//   'templateMapping/getMoreMappingAsync',
//   async function(params:{platforn_field_template_id:number ,paginationdata: {page: number; limit: number}}, toolkit){
//     return await AxiosClient('GET',`/platform-field-template/${params.platforn_field_template_id}`, [], toolkit, params.paginationdata )
//   }
// )
export const getMoreMappingAsync = createAsyncThunk(
  'templateMapping/getMoreMappingAsync',
  async function (
    params: {
      platform_id: number
      field_id: number
      paginationdata: {page: number; limit: number; search: string}
    },
    toolkit
  ) {
    const url = `/platform-field-template?platform_id=${params.platform_id}&field_id=${params.field_id}`
    return await AxiosClient('GET', url, [], toolkit, params.paginationdata)
  }
)

export const getMoreMappingByTemplateIdAsync = createAsyncThunk(
  'templateMapping/getMoreMappingByTemplateIdAsync',
  async function (params: { templateId: number | string }, toolkit) {
    return await AxiosClient(
      'GET',
      `/platform-field-template/${params.templateId}`,
      [],
      toolkit,
      []
    )
  }
)


export const updateMoreMappingAsync = createAsyncThunk(
  'templateMapping/updateMoreMappingAsync',
  async function (params: {platforn_field_template_id: string; payload: any}, toolkit) {
    return await AxiosClient(
      'PUT',
      `/platform-field-template/${params.platforn_field_template_id}`,
      params.payload,
      toolkit,
      []
    )
  }
)


export const deleteMoreMappingAsync = createAsyncThunk(
  'templateMapping/deleteMoreMappingAsync',
  async function (params: {platforn_field_template_id: string}, toolkit) {
    return await AxiosClient(
      'DELETE',
      `/platform-field-template/${params.platforn_field_template_id}`,
      [],
      toolkit,
      []
    )
  }
)


export const getPlatformFieldOtherTemplatesAsync = createAsyncThunk(
  'templateMapping/getPlatformFieldOtherTemplatesAsync',
  async function (params: {platform_id: string; field_id: string}, toolkit) {
    return await AxiosClient('GET', `/platform-field-template`, [], toolkit, params)
  }
)


export const deleteMoreMappingDataAsync = createAsyncThunk(
  'templateMapping/deleteMoreMappingDataAsync',
  async function (params: {platforn_field_template_data_id: string}, toolkit) {
    return await AxiosClient(
      'DELETE',
      `/platform-field-template-data/${params.platforn_field_template_data_id}`,
      [],
      toolkit,
      []
    )
  }
)


//with search get attribute data
export const getPlatformCategoryAttributeDataAsync = createAsyncThunk(
  'templateMapping/getPlatformCategoryAttributeDataAsync',
  async function (params: {category_attribute_id: any; paramsData: any}, toolkit) {
    return await AxiosClient(
      'GET',
      `/api/platform-category-attribute-data/${params.category_attribute_id}`,
      [],
      toolkit,
      params.paramsData
    )
  }
)

export type ListingProfileAiSuggestionPayload = {
  platform_id: number
  source_platform_id: number
  mapping_data: {
    check_platform_field: string | number
    check_operator: string
    check_conjunction: string
    check_value: string
  }[]
  /** Present on poll requests after initial 206 queue response */
  queue_id?: string
}

export const getCategorySuggestionAsync = createAsyncThunk(
  'templateMapping/getCategorySuggestionAsync',
  async function (payload: ListingProfileAiSuggestionPayload, toolkit) {
    return await AxiosClient('POST', '/api/get-category-suggestion', payload, toolkit, [])
  }
)

export const getMappingRulesAsync = createAsyncThunk(
  'templateMapping/getMappingRulesAsync',
  async function (payload: ListingProfileAiSuggestionPayload, toolkit) {
    return await AxiosClient('POST', '/api/get-mapping-rules', payload, toolkit, [])
  }
)
